import { Box, InputLabel, TextField } from "@mui/material";

interface FormInputProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

export default function FormInput({
  label,
  value,
  onChange,
  required = false,
}: FormInputProps) {
  return (
    <Box mb={3}>
      <InputLabel
        htmlFor={label}
        sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}
      >
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </InputLabel>
      <TextField
        fullWidth
        size="medium"
        id={label}
        placeholder={`Enter ${label}`}
        value={value}
        onChange={onChange}
      />
    </Box>
  );
}
